// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'quer... Remove this comment to see the full error message
import qs from 'query-string';

// wrapper function to decouple query string library from the implementation details;
export function objectToQueryString(params: $TSFixMe) {
  return qs.stringify(params);
}
